import { WebGLEngine } from "./WebGLEngine";
export class WebGLBufferState {
    constructor() {
        this._glVertexState = WebGLEngine.instance.createVertexState();
    }
    applyVertexBuffers() {
        this._glVertexState.applyVertexBuffer(this._vertexBuffers);
    }
    applyIndexBuffers() {
        this._glVertexState.applyIndexBuffer(this._bindedIndexBuffer);
    }
    applyState(vertexBuffers, indexBuffer) {
        this._vertexBuffers = vertexBuffers.slice();
        this._bindedIndexBuffer = indexBuffer;
        indexBuffer && indexBuffer._glBuffer.unbindBuffer();
        this.bind();
        this.applyVertexBuffers();
        this.applyIndexBuffers();
        this.unBind();
        indexBuffer && indexBuffer._glBuffer.unbindBuffer();
    }
    bind() {
        this._glVertexState.bindVertexArray();
        WebGLBufferState._curBindedBufferState = this;
    }
    unBind() {
        if (WebGLBufferState._curBindedBufferState == this) {
            this._glVertexState.unbindVertexArray();
            WebGLBufferState._curBindedBufferState = null;
        }
        else {
            throw "BufferState: must call bind() function first.";
        }
    }
    isBind() {
        return (WebGLBufferState._curBindedBufferState == this);
    }
    destroy() {
        if (WebGLBufferState._curBindedBufferState == this) {
            this._glVertexState.unbindVertexArray();
            WebGLBufferState._curBindedBufferState = null;
        }
        this._glVertexState.destroy();
        this._vertexBuffers = null;
        this._bindedIndexBuffer = null;
    }
}
